import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { UnsavedChangesModalProps } from './UnsavedChangesModal';

export const renderUnsavedChangesModal = ({ onClose, ...data }: UnsavedChangesModalProps) =>
    openPopupHelper({ popupName: popupNames.UNSAVED_CHANGES_MODAL, data, onClose });

export const closeUnsavedChangesModal = () => closePopupHelper(popupNames.UNSAVED_CHANGES_MODAL);
